import { RootState } from '@src/redux/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import { GLOBAL_STATE, LETTER_INCOMING_LIST, LETTER_OUTGOING_LIST } from '../constants/actionTypes'

const inquirySelector = (state: RootState) => prop(GLOBAL_STATE, state)

export const letterIncomingSelector = createSelector(inquirySelector, data => data[LETTER_INCOMING_LIST])

export const letterOutgoingSelector = createSelector(inquirySelector, data => data[LETTER_OUTGOING_LIST])
